import { faker } from '@faker-js/faker/locale/ja';
import { HttpResponse, delay, http } from 'msw';
import { FIXED_REF_DATE } from '../../constants';

faker.seed();
// const reportFormType = {
//   ApReportFormInputCheckBox: 'ApReportFormInputCheckBox',
//   ApReportFormInputInvoiceInstantPayee: 'ApReportFormInputInvoiceInstantPayee',
//   ApReportFormInputReportNumberForExpenseField:
//     'ApReportFormInputReportNumberForExpenseField',
//   ApReportFormInputContractNumberField: 'ApReportFormInputContractNumberField',
//   ApReportFormInputInvoiceRegistrationNumberField:
//     'ApReportFormInputInvoiceRegistrationNumberField',
//   ApReportFormInputSelect: 'ApReportFormInputSelect',
//   ApReportFormInputDateField: 'ApReportFormInputDateField',
//   ApReportFormInputNumberField: 'ApReportFormInputNumberField',
//   ApReportFormInputSpecialExceptionStatusSelect:
//     'ApReportFormInputSpecialExceptionStatusSelect',
//   ReportFormStatusContainer: 'ReportFormStatusContainer',
//   ApReportFormInputDeptSelect: 'ApReportFormInputDeptSelect',
//   ApReportFormInputNumberFieldForBranch:
//     'ApReportFormInputNumberFieldForBranch',
//   ApReportFormInputTextArea: 'ApReportFormInputTextArea',
//   ApReportFormInputExItemSelect: 'ApReportFormInputExItemSelect',
//   ApReportFormInputPayeeSelect: 'ApReportFormInputPayeeSelect',
//   ApReportFormInputTextField: 'ApReportFormInputTextField',
//   ApReportFormInputFileField: 'ApReportFormInputFileField',
//   ApReportFormInputProjectSelect: 'ApReportFormInputProjectSelect',
//   ApReportFormInputTimeField: 'ApReportFormInputTimeField',
//   ApReportFormInputInvoiceBookDateField:
//     'ApReportFormInputInvoiceBookDateField',
//   ApReportFormInputRadioButton: 'ApReportFormInputRadioButton',
//   ApReportFormInputInvoiceDueDateField: 'ApReportFormInputInvoiceDueDateField',
//   ApReportFormInputReceiptType: 'ApReportFormInputReceiptType',
// };

// const reportFormInputsData = [
//   {
//     annotation: ['test', 'test1'],
//     default_value: ['test'],
//     has_other_value: false,
//     id: faker.word.sample(),
//     input_options: getGetApPayees(1),
//     input_values: undefined,
//     is_editable: faker.datatype.boolean(), // for setting, it is unused at edit page
//     is_hidden: faker.datatype.boolean(), // for setting, it is unused at edit page
//     is_required: true,
//     label: '支払先',
//     priority: faker.number.int({ min: undefined, max: undefined }),
//     type: reportFormType.ApReportFormInputPayeeSelect,
//   },
// ];

export const getGetInvoiceReportsMock = () => ({
  id: 'M9X9hw-4lnmdpOhMJPGn_g',
  title: '2024年10月支払依頼',
  report_dept: {
    dept_and_position_name: '部門なし',
    fixed_dept_and_position_name: '部門なし',
    initial_selected_id: '0',
    is_changeable: true,
    is_viewable: true,
  },
  status: 'unsubmitted',
  number: 'AP1138',
  number_without_prefix: 1138,
  submitted_at: null,
  approved_at: null,
  created_at: '2024-10-28T18:51:37+09:00',
  updated_at: '2024-11-08T19:46:39+09:00',
  flash_messages: [],
  report_type: {
    id: '051Dq7-RWhIVs_J9bz2LzA',
    name: '支払依頼',
  },
  report_form_inputs: [
    {
      id: '8WxGG2OVVPztq9cx2RTmag',
      label: '支払先種別',
      type: 'ApReportFormInputInvoicePayeeType',
      priority: 0,
      is_required: true,
      is_hidden: false,
      is_editable: false,
      has_other_value: false,
      default_value: '1005',
      annotation: '',
      input_options: [
        {
          id: 'LhmqtGuYLBR_m2jWnlaisg',
          ap_report_form_input_option_master_id: 1005,
          value: '登録済みの支払先',
          display_value: '登録済みの支払先',
          priority: 1,
        },
        {
          id: 'MslzAzJ1-FPqru_foi2Q6A',
          ap_report_form_input_option_master_id: 1006,
          value: 'スポット支払（未登録の支払先）',
          display_value: 'スポット支払（未登録の支払先）',
          priority: 2,
        },
      ],
      input_values: [
        {
          id: '2AVRqUi1qzcK-QudXDxBdg',
          value: '1005',
        },
      ],
      input_additional_values: null,
    },
    {
      id: '9vcyxeq0tB20bQFYcoaraw',
      label: '支払先',
      type: 'ApReportFormInputInvoicePayeeSelect',
      priority: 1,
      is_required: true,
      is_hidden: false,
      is_editable: false,
      has_other_value: false,
      default_value: null,
      annotation: '支払先が無い場合は管理者に登録を依頼してください',
      input_options: null,
      input_values: [
        {
          id: 'xRCMFchmk6xj0ClVM6mdpg',
          value: 'aCkOVet_cb2z-uLXgVQ0YQ',
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'o6vpshKaWxSRSoo-L_2Qcw',
      label: '支払先(スポット支払)',
      type: 'ApReportFormInputInvoiceInstantPayee',
      priority: 2,
      is_required: true,
      is_hidden: false,
      is_editable: false,
      has_other_value: false,
      default_value: null,
      annotation: '',
      input_options: null,
      input_values: null,
      input_additional_values: null,
    },
    {
      id: 'JR8vsZGAYeOLufXBiqjPxg',
      label: '特例区分',
      type: 'ApReportFormInputSpecialExceptionStatus',
      priority: 3,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: '',
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: '23iLnaVz7Ly4vPZZluHBhA',
          value: '0',
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'JomjIKEPZMvTLJ78PxvmZA',
      label: '適格請求書発行事業者登録番号',
      type: 'ApReportFormInputInvoiceRegistrationNumberField',
      priority: 4,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: '',
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: 'QNSLieiIGl5NQQsXjd0z5A',
          value: '',
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'p67_FhRVTzphnfBVUYBeWA',
      label: '請求書画像',
      type: 'ApReportFormInputInvoiceFileField',
      priority: 5,
      is_required: false,
      is_hidden: false,
      is_editable: false,
      has_other_value: false,
      default_value: null,
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: 'C3FjO9L_kCENSm7vGCfpPg',
          value: 'prEqTv8Obt9YRNG7oCGtfw',
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'bQS7rRgT6xc8K53bexhJXg',
      label: '請求書の受領区分',
      type: 'ApReportFormInputReceiptType',
      priority: 6,
      is_required: false,
      is_hidden: false,
      is_editable: false,
      has_other_value: false,
      default_value: '',
      annotation: '請求書画像が添付された時のみ、必須項目になります',
      input_options: [
        {
          id: 'yAsHYR97lSzYEJdRgenShg',
          ap_report_form_input_option_master_id: 1003,
          value: '1003',
          display_value: '電子 (PDF,JPEG等) で受領した請求書',
          priority: 1,
        },
        {
          id: 'CDKbx9n3NOWGohCowI038A',
          ap_report_form_input_option_master_id: 1004,
          value: '1004',
          display_value: '紙で受領した請求書',
          priority: 2,
        },
      ],
      input_values: [
        {
          id: 'upJF0NbJWM26tApSEMBfzw',
          value: '1003',
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'MF0QySkZ4YmWUFqJ9RP1eA',
      label: '取引関係書類',
      type: 'ApReportFormInputBusinessDocumentsField',
      priority: 7,
      is_required: false,
      is_hidden: false,
      is_editable: false,
      has_other_value: false,
      default_value: null,
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: 'UUybTANP4SbzokldLUJIrA',
          value: null,
        },
      ],
      input_additional_values: null,
    },
    {
      id: '9R6VsBnZrDmDBN3CPLPYeA',
      label: '支払期日',
      type: 'ApReportFormInputInvoiceDueDateField',
      priority: 8,
      is_required: true,
      is_hidden: false,
      is_editable: false,
      has_other_value: false,
      default_value: null,
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: '4MMVftHsZY3BWT3-aNTxzw',
          value: '2024/11/11',
        },
      ],
      input_additional_values: null,
    },
    {
      id: '6RIKWrgVhQZ28JThMe_9NQ',
      label: '費用計上日',
      type: 'ApReportFormInputInvoiceBookDateField',
      priority: 9,
      is_required: true,
      is_hidden: false,
      is_editable: false,
      has_other_value: false,
      default_value: null,
      annotation: 'デフォルトは前月末日付となります',
      input_options: null,
      input_values: [
        {
          id: 'VufJ3vOpPGE5QtC5SqyKeQ',
          value: '2024/10/20',
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'b4fTGfrwQGfPWhbDBzAykQ',
      label: '目的',
      type: 'ApReportFormInputTextArea',
      priority: 10,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: '',
      annotation: '目的を記載してください',
      input_options: null,
      input_values: [
        {
          id: 'fhM7R0JerLLCwk6LLpVZig',
          value: '',
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'ah-kDYBhmKWjToOlhXuJAA',
      label: '申請番号',
      type: 'ApReportFormInputReportNumberForExpenseField',
      priority: 11,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: '',
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: 'kFPYQ7Q7dpI_TOSlPZpTWQ',
          value: '',
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'SdYMtsqwfrLtq0xV-E8ezQ',
      label: '非表示項目',
      type: 'ApReportFormInputTextField',
      priority: 12,
      is_required: false,
      is_hidden: true,
      is_editable: true,
      has_other_value: false,
      default_value: '',
      annotation: '',
      input_options: null,
      input_values: null,
      input_additional_values: null,
    },
    {
      id: 'sBPvKhFm9HGUB0IZkXcXKw',
      label: '選択肢',
      type: 'ApReportFormInputCheckBox',
      priority: 13,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: true,
      default_value: '',
      annotation: '',
      input_options: [
        {
          id: 'GhhMsLm2MTGMcqCzkGdsoQ',
          ap_report_form_input_option_master_id: null,
          value: '11',
          display_value: '11',
          priority: 1,
        },
        {
          id: 'rmlBbYYDyVjYE3fCaREhtA',
          ap_report_form_input_option_master_id: null,
          value: '22',
          display_value: '22',
          priority: 1,
        },
        {
          id: 'Y-WQ-_zjGeoLhUHpO4NdyQ',
          ap_report_form_input_option_master_id: null,
          value: '33',
          display_value: '33',
          priority: 1,
        },
      ],
      input_values: [
        {
          id: 'WlgloIQLVAo54FzUS0brfQ',
          value: '',
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'ks4_UunenAVKw1Vm_TKB6g',
      label: '数値',
      type: 'ApReportFormInputNumberField',
      priority: 14,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: '',
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: '9HQrOBvbWK9RCHEVZBsXvg',
          value: null,
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'ZQBWOnqUD19N25-UosNO_Q',
      label: '添付ファイル',
      type: 'ApReportFormInputFileField',
      priority: 15,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: null,
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: 'inHLEh6vmXY62LVG6zCW9w',
          value: null,
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'iDvFkygkW_CaN7tx58JAmQ',
      label: '費用科目',
      type: 'ApReportFormInputProjectSelect',
      priority: 16,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: null,
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: 'IEYzRcZn6MxWLYWX20sOeg',
          value: null,
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'FbnNuV6cpxl2AtyDY40aOA',
      label: '分岐条件利用',
      type: 'ApReportFormInputNumberFieldForBranch',
      priority: 17,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: '3',
      annotation: '分岐条件利用',
      input_options: null,
      input_values: [
        {
          id: 'NG2JwK_8t5O3UF3P2lOWlA',
          value: '3',
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'AXpcaqHyUugrURIhGSFcAA',
      label: '日時',
      type: 'ApReportFormInputTimeField',
      priority: 18,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: null,
      annotation: '日付',
      input_options: null,
      input_values: [
        {
          id: 'l9ehnDl5MQJquvc0Ais9Vg',
          value: null,
        },
      ],
      input_additional_values: null,
    },
    {
      id: '1AIFNo2uFG6wq_ypgaihZg',
      label: 'OfficeMember',
      type: 'ApReportFormInputOfficeMemberSelect',
      priority: 19,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: null,
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: 'OXVN3LxmzudJNkfzDvr7pw',
          value: null,
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'MJ5GxVToep0Qbas-OSqrIQ',
      label: '部門',
      type: 'ApReportFormInputDeptSelect',
      priority: 20,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: null,
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: '0pHV7llhYTKczxWw_kiKqQ',
          value: null,
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'WHiaLkRiLQGw5F5b9g75QQ',
      label: 'pj',
      type: 'ApReportFormInputProjectSelect',
      priority: 21,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: null,
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: '-uYRUElK5als5OSr6ZuCdQ',
          value: null,
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'Wb9wZt-QdZF-QDyqRiF1JQ',
      label: 'exItem',
      type: 'ApReportFormInputExItemSelect',
      priority: 22,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: null,
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: 'SpH28M8VkYbZURQDxZaznA',
          value: null,
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'k7qISGQSFL0Kv-WkWGCu4g',
      label: 'aaa',
      type: 'ApReportFormInputSelect',
      priority: 23,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: true,
      default_value: '',
      annotation: '',
      input_options: [
        {
          id: 'r9rnJ6ZsDW_reYhcbJqXUg',
          ap_report_form_input_option_master_id: null,
          value: '1',
          display_value: '1',
          priority: 0,
        },
        {
          id: 'Ex5y6xzZLpbvGwbIYZs35g',
          ap_report_form_input_option_master_id: null,
          value: '2',
          display_value: '2',
          priority: 1,
        },
        {
          id: 'voJkxpzIqvUyay1rRjLmiA',
          ap_report_form_input_option_master_id: null,
          value: '3',
          display_value: '3',
          priority: 2,
        },
      ],
      input_values: [
        {
          id: 'COw84ZTr3whUYEQHgZNjYA',
          value: 'aiueo',
        },
      ],
      input_additional_values: null,
    },
    {
      id: '9Ygx3QBkyIALey3UrEWmhg',
      label: '事前申請番号',
      type: 'ApReportFormInputReportNumberForExpenseField',
      priority: 24,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: '',
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: 'aXN-rRTGQN1NEvgGYOtuOQ',
          value: '',
        },
      ],
      input_additional_values: null,
    },
    {
      id: 'GM8eoUcbAiAvSRjaRgrXqA',
      label: '契約番号',
      type: 'ApReportFormInputContractNumberField',
      priority: 25,
      is_required: false,
      is_hidden: false,
      is_editable: true,
      has_other_value: false,
      default_value: '',
      annotation: '',
      input_options: null,
      input_values: [
        {
          id: '4sIcv6_K1HIsrKoVgLCLLA',
          value: '',
        },
      ],
      input_additional_values: null,
    },
  ],
  invoice_file: {
    id: 'mock-invoice-file-id',
    name: '請求書_sample.pdf',
    byte_size: 50000,
    content_type: 'application/pdf',
    cache_content_url: '/invoices/sample.pdf',
    e_doc_meta_datum: {
      dpi_text: `${faker.number.int({ min: 30, max: 600 })} dpi`,
      pixel_number_text: `${faker.number.int({ min: 1, max: 50 })}万画素`,
      rgb_depth_text: `RGB(${faker.number.int({
        min: 100,
        max: 256,
      })}`,
      is_scan: true,
      is_satisfy_resolution_requirement: true,
      is_satisfy_depth_requirements: true,
    },
  },
  is_e_doc_ap_receipt_type_enabled: true,
});

export const getGetInvoiceTransactionsMock = () => ({
  invoice_transactions: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      ap_payee: faker.helpers.arrayElement([
        {
          id: faker.helpers.arrayElement([faker.word.sample()]),
          name: faker.helpers.arrayElement([faker.word.sample()]),
        },
      ]),
      ap_payee_type: faker.helpers.arrayElement([faker.word.sample()]),
      ap_report_id: faker.helpers.arrayElement([faker.word.sample()]),
      cr_item: faker.helpers.arrayElement([
        {
          id: faker.helpers.arrayElement([faker.word.sample()]),
          name: faker.helpers.arrayElement([faker.word.sample()]),
        },
      ]),
      cr_sub_item: faker.helpers.arrayElement([
        {
          id: faker.helpers.arrayElement([faker.word.sample()]),
          name: faker.helpers.arrayElement([faker.word.sample()]),
        },
      ]),
      currency: faker.helpers.arrayElement([faker.word.sample()]),
      deal_date: faker.helpers.arrayElement([
        faker.date
          .past({ refDate: FIXED_REF_DATE })
          .toISOString()
          .split('T')[0],
      ]),
      dept: faker.helpers.arrayElement([
        {
          id: faker.helpers.arrayElement([faker.word.sample()]),
          name: faker.helpers.arrayElement([faker.word.sample()]),
        },
      ]),
      dr_excise: faker.helpers.arrayElement([
        {
          id: faker.helpers.arrayElement([faker.word.sample()]),
          name: faker.helpers.arrayElement([faker.word.sample()]),
        },
      ]),
      ex_item: faker.helpers.arrayElement([
        {
          id: faker.helpers.arrayElement([faker.word.sample()]),
          name: faker.helpers.arrayElement([faker.word.sample()]),
        },
      ]),
      excise_value: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
      ]),
      has_withholding_income_tax: faker.helpers.arrayElement([
        faker.datatype.boolean(),
      ]),
      id: faker.helpers.arrayElement([faker.word.sample()]),
      invoice_kind: faker.helpers.arrayElement([faker.word.sample()]),
      jpyrate: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
      ]),
      memo: faker.helpers.arrayElement([faker.word.sample()]),
      name: faker.helpers.arrayElement([faker.word.sample()]),
      number: faker.helpers.arrayElement([faker.word.sample()]),
      project_code: faker.helpers.arrayElement([
        {
          id: faker.helpers.arrayElement([faker.word.sample()]),
          name: faker.helpers.arrayElement([faker.word.sample()]),
        },
      ]),
      quantity: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
      ]),
      total_value: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
      ]),
      unit_value: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
      ]),
      use_custom_jpy_rate: faker.helpers.arrayElement([
        faker.datatype.boolean(),
      ]),
      withholding_income_tax_value: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
      ]),
    })),
  ]),
});

export const getSearchInvoiceReportsMock = () => ({
  invoice_reports: Array.from({ length: 25 }, () => ({
    ap_payee_name: '株式会社テストクリエイティブソリューションズ',
    approved_at: '2025-04-30T00:00:00Z',
    book_date: '2025-04-30',
    created_at: '2025-04-30T00:00:00Z',
    detail_path: '/invoice_reports/AP1234',
    due_date: '2025-04-30',
    edit_path: '/invoice_reports/AP1234/edit',
    payment_date: '2025-05-15',
    payment_status: faker.helpers.arrayElement(['not_yet_paid', 'paid', null]),
    id: `AP${faker.number.int({ min: 1000, max: 9999 })}`,
    invoice_file: {
      byte_size: 1024,
      cache_content_url: '#',
      can_delete: false,
      content_type: 'application/pdf',
      id: 'file-1234',
      receipt_type: '電子取引',
      filename:
        'WPDW0000001_multiple_excise + multiple item_20250811111806.pdf',
    },
    is_cancelable: faker.datatype.boolean(),
    is_copyable: faker.datatype.boolean(),
    is_deletable: faker.datatype.boolean(),
    is_editable: faker.datatype.boolean(),
    number: `AP${faker.number.int({ min: 1000, max: 9999 })}`,
    office_member: {
      display_name: '田中一二三',
      id: '100',
      name: '田中一二三',
      number: '100',
    },
    report_approval_names: '佐藤次郎,高橋敏徳,鈴木拓,山田太郎',
    status: (() => {
      const statusMap = [
        { key: 'unsubmitted', display_name: '下書き' },
        { key: 'approved', display_name: '承認済み' },
        { key: 'rejected', display_name: '差戻し' },
        { key: 'canceled', display_name: '取消し' },
        { key: 'unsubmitted', display_name: '未申請' },
        { key: 'waiting_step_one', display_name: '第一承認待ち' },
        { key: 'waiting_step_two', display_name: '第二承認待ち' },
      ];
      return statusMap[Math.floor(Math.random() * statusMap.length)];
    })(),
    submitted_at: '2025-04-30T00:00:00Z',
    title: '2025年5月支払依頼 - 詳細な説明と追加の情報を含む長いタイトル',
    total_amount: '100,000',
    foreign_currency_amount: '(100,000)',
    automatic_status_waiting: faker.helpers.arrayElement([
      'before_flair_upload',
      'flair_uploaded',
      'before_streamed_upload',
      'streamed_uploaded',
      'before_ocr_upload',
      'ocr_uploaded',
      undefined,
    ]),
    timestamp_status_creating: faker.helpers.arrayElement([
      'creating',
      undefined,
    ]),
    error_messages: [
      {
        message_type: 'duplicate_reports_message',
        type: 'warn',
        label: '類似申請',
        message:
          '類似の支払依頼が申請されています。申請番号：AP90000（佐藤次郎）',
      },
    ],
    cannot_cancel_reason: null,
  })),
  pagination: {
    has_next_page: true,
    has_previous_page: false,
    page: 1,
    per_page: 25,
    total_pages: 10,
    total_records: 250,
  },
});

export const getGetInvoiceReportPaymentStatusesMock = () => [
  {
    display_name: '未払い',
    value: 'not_yet_paid',
  },
  {
    display_name: '支払い済み',
    value: 'paid',
  },
];

export const handlers = [
  http.post('*/api/js/invoice_reports/search', async () => {
    await delay(1000);
    return new HttpResponse(JSON.stringify(getSearchInvoiceReportsMock()), {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }),
  http.get('*/api/js/invoice_reports/payment_statuses', async () => {
    await delay(1000);
    return new HttpResponse(
      JSON.stringify(getGetInvoiceReportPaymentStatusesMock()),
      {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }),
  http.get('*/api/js/invoice_reports/:id', async () => {
    await delay(1000);
    return new HttpResponse(JSON.stringify(getGetInvoiceReportsMock()), {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }),
  http.get('*/api/js/invoice_reports/:id/invoice_transactions', async () => {
    await delay(1000);
    return new HttpResponse(JSON.stringify(getGetInvoiceTransactionsMock()), {
      status: 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }),
];
